import { Checkbox, Modal } from 'antd';
import React, { useState } from 'react';

import { SList, SListItem } from 'app/components/StaycationUI/List';
import type { RoomType } from 'app/components/commons/Package/General/Types';
import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';

import './RoomModal.scss';

export const RoomModal = ({ visible, onSelect, onCancel, allRooms }: Props) => {
  const [selectedRooms, setSelectedRooms] = useState<RoomType[]>([]);

  if (!allRooms) {
    return null;
  }

  const handleSelect = (room: RoomType) => {
    if (selectedRooms.some((e) => e.id === room.id)) {
      setSelectedRooms(selectedRooms.filter((e) => e.id !== room.id));
    } else {
      setSelectedRooms([...selectedRooms, room]);
    }
  };

  const renderAvatar = (room: RoomType) =>
    room.avatar ? (
      <div className="room-modal__item__avatar">
        <PictureComponent {...(room.emoji || room.avatar)} width={54} />
      </div>
    ) : null;

  const renderRoom = (room: RoomType, idx: number) => (
    <SListItem
      title={room.title}
      description={room.description}
      avatar={renderAvatar(room)}
      actions={[
        <Checkbox
          checked={selectedRooms.some((e) => e.id === room.id)}
          key="checkbox"
        />,
      ]}
      onClick={() => handleSelect(room)}
      className="room-modal__item"
      key={idx.toString()}
    />
  );

  const sortRooms = (rooms: RoomType[]) =>
    [...rooms].sort((a, b) => {
      if (a.published !== b.published) {
        return a.published ? -1 : 1;
      }

      return (a.roomOrder ?? 0) - (b.roomOrder ?? 0);
    });

  return (
    <Modal
      width={800}
      onOk={() => {
        onSelect(selectedRooms);
        setSelectedRooms([]);
        onCancel();
      }}
      okText="Save"
      onCancel={() => {
        onCancel();
        setSelectedRooms([]);
      }}
      open={visible}
      title={`Choose rooms`}
      centered
      className="room-modal"
    >
      <SList
        data={sortRooms(allRooms) || []}
        renderItem={renderRoom}
        split={false}
      />
    </Modal>
  );
};

type Props = {
  visible: boolean;
  onSelect: (rooms: RoomType[]) => void;
  onCancel: () => void;
  allRooms?: RoomType[];
};
